export const CREATE_NEW_PROPERTY = 'create-new-property';
export const SPLIT_ROW = 'split-row';
export const CREATE_DEPENDENT_FIELD_RULE = 'create-dependent-field-rule';
export const DELETE_DEPENDENT_FIELD_RULE = 'delete-dependent-field-rule';
export const ENABLE_SMART_FIELD = 'enable-smart-field';
export const DISABLE_SMART_FIELD = 'disable-smart-field';
export const VIEW_LOGIC_CONFIG = 'view-logic-config';
export const SELECT_FIELD = 'select-field';
export const SHOW_DEPENDENT_FIELDS = 'show-dependent-fields';
export const HIDE_DEPENDENT_FIELDS = 'hide-dependent-fields';
export const DRAGGED_NEW_FIELD_TILE = 'dragged-new-field-tile';
export const CLICKED_CREATE_FIELD_TILE = 'clicked-create-field-tile';
export const ENABLE_TICKET_PROPERTIES = 'enable-ticket-properties';
export const DISABLE_TICKET_PROPERTIES = 'disable-ticket-properties';
export const SEARCH_PROPERTIES = 'search-properties';
export const ABM_CREATE_NEW_FIELD_HINT = 'abm-create-new-field-hint';
export const DRAGGED_FIELD_INTO_DEAD_ZONE = 'dragged-field-into-dead-zone';
export const TRANSLATE_FORM_FROM_CLONE = 'translate-form-from-clone';
export const APPEND_FORM_FIELD = 'append-form-field';
export const TOGGLE_PROPERTY_ACCORDION = 'toggle-property-accordion';
export const MAKE_REQUIRED_INLINE = 'make-required-inline';
export const MAKE_REQUIRED_PANEL = 'make-required-panel';
export const MAKE_HIDDEN_PANEL = 'make-hidden-panel';
export const EDITED_LABEL = 'edited-label';
export const EDITED_HELP_TEXT = 'edited-help-text';
export const EDITED_PLACEHOLDER = 'edited-placeholder';
export const EDITED_DEFAULT_VALUE = 'edited-default-value';
export const EDITED_EMAIL_DOMAINS_TO_BLOCK = 'edited-email-domains-to-block';
export const CLICK_ADD_ANOTHER_DEPENDENT_RULE = 'click-add-another-dependent-rule';
export const CLICK_EDIT_DEPENDENT_RULE = 'click-edit-dependent-rule';
export const TOGGLE_QUEUED_PROGRESSIVE_FIELD_ACCORDION = 'toggle-queued-progressive-field-accordion';
export const TOGGLE_CAPTCHA_OTHER_FORM_ELEMENTS = 'toggle-captcha-other-form-elements';
export const DELETE_CATCHA_INFO_BUTTON_GROUP = 'delete-captcha-info-button-group';
export const TOGGLE_INFO_CAPTCHA_INFO_BUTTON_GROUP = 'toggle-info-catpcha-info-button-group';
export const DRAG_DROP_REORDERED_FORM_FIELD_TO_EXISTING_GROUP = 'drag-drop-reordered-form-field-to-existing-group';
export const DRAG_DROP_REORDERED_FORM_FIELD_TO_NEW_GROUP = 'drag-drop-reordered-form-field-to-new-group';
export const DRAG_DROP_REORDERED_FORM_FIELD_TO_NEW_QUEUED_PROGRESSIVE_FIELD_GROUP = 'drag-drop-reordered-form-field-to-new-queued-progressive-field-group';
export const DRAG_DROP_ADDED_FORM_FIELD_FROM_PANEL_TO_EXISTING_GROUP = 'drag-drop-added-form-field-group-from-panel-to-existing-group';
export const DRAG_DROP_ADDED_FORM_FIELD_FROM_PANEL_TO_NEW_GROUP = 'drag-drop-added-form-field-group-from-panel-to-new-group';
export const DRAG_DROP_ADDED_FORM_FIELD_TO_QUEUED_PROGRESSIVE_FIELDS = 'drag-drop-added-form-field-to-queued-progressive-fields';
export const DRAG_DROP_REORDERED_RICH_TEXT = 'drag-drop-reordered-rich-text';
export const DELETE_FORM_FIELD_FLOATING_BUTTON = 'delete-form-field-floating-button';
export const UPDATE_GDPR_OPTION = 'update-gdpr-option';
export const UPDATE_GDPR_PROPERTY = 'update-gdpr-option';
export const UPDATE_GDPR_CONSENT_TEXT = 'update-gdpr-consent-text';
export const UPDATE_GDPR_PRIVACY_TEXT = 'update-gdpr-privacy-text';
export const UPDATE_GDPR_CHECKBOX = 'update-gdpr-checkbox';
export const DELETE_GDPR_CHECKBOX = 'delete-gdpr-checkbox';
export const REVERT_PAYMENT_CHANGES = 'revert-payment-changes';